import classNames from "classnames";
import { EventKey } from "PFCore/types/event_key";
import { ComponentProps } from "react";

import css from "./action_tile.module.scss";
import { Tile } from "./tile";

type ActionTileProps = Pick<
  ComponentProps<typeof Tile>,
  "className" | "paddingVariant" | "children" | "style" | "onClick" | "onKeyDown" | "aria-label"
> & {
  selected?: boolean;
};

export const ActionTile = ({
  className,
  selected,
  onClick,
  onKeyDown,
  "aria-label": ariaLabel,
  ...props
}: ActionTileProps) => {
  const handleKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (event) => {
    if (event.key === EventKey.Enter || event.key === EventKey.Space) {
      event.preventDefault();
      onClick?.(event as unknown as React.MouseEvent<HTMLDivElement>);
    }
    onKeyDown?.(event);
  };

  return (
    <Tile
      className={classNames(css.actionTile, css.light, className, {
        [css.selected]: selected
      })}
      variant="light"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      aria-pressed={selected}
      {...props}
    />
  );
};
